import React from 'react'

import { INumberProps } from 'core-components/library/inputs/Number'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { OnboardingNumberInput } from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { MAX_PERCENT, MIN_PERCENT } from './constants'
import { IPartnerShipNA } from './types'

interface IProps {
  onChange: (field: string, number?: boolean) => (value: string) => void
  item: IPartnerShipNA
  writeAudience: IObjectAny
  disabled?: boolean
}

export const SellingMotionNa = ({ onChange, item, writeAudience, disabled }: IProps) => {
  return (
    <div>
      <div className={styles.text__title}>
        Selling Motion <div className={styles.text__rule}>{`(Applies to T1 & T2 Reseller)`}</div>
      </div>
      <div className={styles.text}>
        Who are your primary customers? Value should add up to {MAX_PERCENT}%
      </div>
      <VisualAudienceExtended<INumberProps>
        component={OnboardingNumberInput}
        write={writeAudience}
        margin={'md'}
        label={'Individuals (%)'}
        value={item.Individuals ?? undefined}
        min={MIN_PERCENT}
        max={MAX_PERCENT}
        onChange={onChange('Individuals', true)}
        disabled={disabled}
      />
      <VisualAudienceExtended<INumberProps>
        component={OnboardingNumberInput}
        write={writeAudience}
        margin={'md'}
        label={'Companies (%)'}
        value={item.Companies ?? undefined}
        min={MIN_PERCENT}
        max={MAX_PERCENT}
        onChange={onChange('Companies', true)}
        disabled={disabled}
      />
      <VisualAudienceExtended<INumberProps>
        component={OnboardingNumberInput}
        write={writeAudience}
        margin={'md'}
        label={'TotalSellingMotion (%)'}
        min={MIN_PERCENT}
        max={MAX_PERCENT}
        value={item.TotalSellingMotion ?? undefined}
        onChange={onChange('TotalSellingMotion', true)}
        disabled={disabled}
      />
    </div>
  )
}
